module.exports = __webpack_public_path__ + "static/media/20-day.c510375c.png";